export default {
    data: () => ({
        translations: {
            registerUser: {
                el: "Προσθήκη Νέου Χρήστη",
                en: "Add New User",
                it: "Aggiungi Nuovo Utente"
            },
            user: {
                el: "Χρήστης",
                en: "User",
                it: "Utente"
            },
            role: {
                el: "Ρόλος",
                en: "Role",
                it: "Ruolo"
            },
            date: {
                el: "Ημ/νία Δημιουργίας",
                en: "Date Created",
                it: "Data di Creazione"
            },
            enabled: {
                el: "Ενεργοποιημένος",
                en: "Enabled",
                it: "Abilitato"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            yes: {
                el: "Ναι ",
                en: "Yes",
                it: "Si"
            },
            no: {
                el: "Όχι ",
                en: "No",
                it: "No"
            },
            userProfile: {
                el: "Προεπισκόπιση στοιχείων",
                en: "View user details",
                it: "Visualizza i dettagli dell'utente"
            },
            updatePermissions: {
                el: "Ενημέρωση δικαιωμάτων χρήστη",
                en: "Update User Permissions",
                it: "Aggiorna permessi utente"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            upgrade: {
                el: "Αναβάθμιση",
                en: "Upgrade",
                it: "Aggiornamento"
            },
            downgrade: {
                el: "Υποβάθμιση",
                en: "Downgrade",
                it: "Declassamento"
            },
            confirmationMessageSure: {
                el: "Σίγουρα θέλεις να",
                en: "Are you sure you want to",
                it: "Siete sicuri di voler"
            },
            deleteConfirmationMessage: {
                el: " <b>διαγράψεις</b> τον χρήστη ",
                en: " <b>delete</b> user ",
                it: " <b>eliminare</b> l'utente "
            },
            upgradeConfirmationMessage: {
                el: " <b>αναβαθμίσεις</b> τον χρήστη ",
                en: " <b>upgrade</b> the user ",
                it: " <b>aggiornare</b> l'utente "
            },
            downgradeConfirmationMessage: {
                el: " <b>υποβαθμίσεις</b> τον χρήστη ",
                en: " <b>downgrade</b> the user ",
                it: " <b>declassare</b> l'utente "
            },
            downgradeTo: {
                el: "σε <b>moderator</b>",
                en: "to <b>moderator</b>",
                it: "a <b>moderatore</b>"
            },
            upgradeTo: {
                el: " σε <b>manager</b>",
                en: " to <b>manager</b>",
                it: " a <b>manager</b>"
            },
            questionmark: {
                el: ";",
                en: "?",
                it: "?"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancella"
            },
            
            user2: {
                el: "Χρήστη",
                en: "User",
                it: "Utente"
            },
        }
    })
};
